
window.addEventListener('load', () => {
    handleHeaderScroll();
    handleHeaderHomeScroll();

    // Handle on scroll
    window.addEventListener('scroll', () => {
        handleHeaderScroll();
        handleHeaderHomeScroll();
    })


function handleHeaderScroll() {
        // Get header
        const header = document.querySelector("[data-scroll='header']");


        if (header) {
            // Check scroll position
            const scrollPosition = window.scrollY;

            // Check if page has been scrolled
            if (scrollPosition > 50) {
                // If true, add class scrolled
                header.classList.remove('web-header--transparent');
            }
            else {
                // If not, remove class scrolled
                header.classList.add('web-header--transparent');
            }

        }
    }

    function handleHeaderHomeScroll() {
        const headerHome = document.querySelector(`[data-scroll-item="header-scroll"]`);
        const headerTrigger = document.querySelector(`[data-item="scroll-header-trigger"]`);

        if(headerTrigger) {
            const triggerBounding = headerTrigger.getBoundingClientRect();

            if (
                triggerBounding.top <= (window.innerHeight || document.documentElement.clientHeight) &&
                triggerBounding.bottom <= 1500 &&
                triggerBounding.left >= 0 &&
                triggerBounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            ) {
                headerHome.classList.add("scrolled", "header--alt");

            } else if(triggerBounding.top > 100) {
                headerHome.classList.remove("scrolled", "header--alt");
            }
        }
    }
})



